/**
 * Load dynamic range from the Brygga backend. This is to be used for testing purposes only. Will throw errors if experience or change package is not found.
 *
 * @param experienceName the name of the experience to load the dynamic range for
 * @param changePackage (optional) the id or name (with spaces removed) of the change package to load the dynamic range from. Omit to load main.
 * @param env the environment to load the dynamic range from. Defaults to 'prod'
 */
export const loadDynamicRange = async (experienceName, changePackage, env = 'prod') => {
    const url = getIndexFileUrl(env, experienceName, changePackage, 'dr');
    const indexFile = await fetch(url).then(res => res.json());
    console.log(indexFile);
    if (indexFile.error)
        throw new Error(indexFile.error);
    if (!indexFile.import)
        throw new Error('No import paths found in index file');
    const rangePaths = getDynamicRangePaths(indexFile.import);
    return Promise.all(rangePaths.map(rp => fetchDynamicRangeJson(rp, getBaseUrl(env))));
};
/**
 * Load ipex range format from the Brygga backend. This is to be used for testing purposes only. Will throw errors if experience or change package is not found.
 *
 * @param experienceName the name of the experience to load the ipex range format for
 * @param changePackage (optional) the id or name (with spaces removed) of the change package to load the ipex range format from. Omit to load main.
 * @param env the environment to load the ipex range format from. Defaults to 'prod'
 */
export const loadIpexRangeFormat = async (experienceName, changePackage, env = 'prod') => {
    const url = getIndexFileUrl(env, experienceName, changePackage, 'irf');
    const indexFile = await fetch(url).then(res => res.json());
    if (indexFile.error)
        throw new Error(indexFile.error);
    if (!indexFile.import)
        throw new Error('No import paths found in index file');
    return Promise.all(indexFile.import.map(path => fetchIpexRangeFormatJson(path, getBaseUrl(env))));
};
const getBaseUrl = (env) => {
    if (env === 'localhost')
        return 'http://localhost:8080/filesystem';
    return env === 'cte'
        ? 'https://ipex-rms-backend.azurewebsites.net/filesystem'
        : 'https://ipex-brygga-backend-prod.azurewebsites.net/filesystem';
};
const getIndexFileUrl = (env, experienceName, changePackage, format = 'dr') => {
    const baseUrl = getBaseUrl(env);
    const changePackageParam = changePackage ? `?changepkg=${changePackage}` : '';
    return `${baseUrl}/${experienceName}/current/index-${format}.json${changePackageParam}`;
};
const fetchDynamicRangeJson = async (rp, baseUrl) => {
    const catalogUrl = `${baseUrl}/${rp.catalogPath}`;
    const templateUrl = `${baseUrl}/${rp.templatePath}`;
    const catalogPromise = fetch(catalogUrl).then(res => res.text());
    const templatePromise = fetch(templateUrl).then(res => res.text());
    return Promise.all([catalogPromise, templatePromise]).then(([catalog, template]) => {
        return { catalog, template };
    });
};
const fetchIpexRangeFormatJson = async (path, baseUrl) => {
    const catalogUrl = `${baseUrl}/${path}`;
    return fetch(catalogUrl)
        .then(res => res.text())
        .then(r => ({ catalog: r }));
};
const getDynamicRangePaths = (paths) => {
    const rangePaths = [];
    paths.forEach((path, index) => {
        if (path.includes('catalog/')) {
            rangePaths.push({ catalogPath: path, templatePath: paths[index + 1] });
        }
    });
    return rangePaths;
};
//# sourceMappingURL=RangeLoader.js.map